var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"box-radio",class:_vm.color},[_c('input',{attrs:{"type":"radio","name":_vm.name},domProps:{"checked":_vm.checked},on:{"click":_vm.set}}),_c('div',{staticClass:"check"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.labelText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }